(function () {
  'use strict';

  function updateShippingBar() {
    var bar = document.querySelector('.gjones-cart__shipping-bar');
    if (!bar) return;

    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
    var cartTotal = parseInt(bar.getAttribute('data-cart-total'), 10);
    var msgEl = bar.querySelector('.gjones-cart__shipping-msg');
    var fillEl = bar.querySelector('.gjones-cart__shipping-fill');
    var msgTemplate = bar.getAttribute('data-message');
    var successMsg = bar.getAttribute('data-success');

    if (!threshold || !fillEl || !msgEl) return;

    var remaining = threshold - cartTotal;
    var pct = Math.min((cartTotal / threshold) * 100, 100);

    fillEl.style.width = pct + '%';

    if (remaining <= 0) {
      bar.classList.add('gjones-cart__shipping-bar--done');
      msgEl.innerHTML = successMsg;
    } else {
      bar.classList.remove('gjones-cart__shipping-bar--done');
      var formatted = bar.getAttribute('data-currency-symbol') + (remaining / 100).toFixed(2);
      msgEl.innerHTML = msgTemplate.replace('{amount}', '<strong>' + formatted + '</strong>');
    }
  }

  function init() {
    updateShippingBar();

    // Re-run whenever cart drawer re-renders (Dawn fires this)
    document.addEventListener('cart:updated', updateShippingBar);

    // Also observe DOM for cart-drawer-items changes (Dawn swaps innerHTML)
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems) {
      new MutationObserver(function () {
        // bar may have been re-rendered, re-query
        setTimeout(updateShippingBar, 50);
      }).observe(drawerItems, { childList: true, subtree: true });
    }

    // Listen for cart drawer open to refresh bar with latest total
    document.addEventListener('cart-drawer:open', function () {
      var bar = document.querySelector('.gjones-cart__shipping-bar');
      if (!bar) return;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          bar.setAttribute('data-cart-total', data.total_price);
          updateShippingBar();
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
